import React from 'react';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { SaveDailyReportForm } from 'modules/components/layer12';
import { useParams } from 'react-router-dom';

export type SaveDailyReportModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: SaveDailyReportModalProps) => {
  const params = useParams();
  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Save daily report'
      subTitle='Enter details in order to save them to the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <SaveDailyReportForm.FC
        id={props.id}
        projectId={params.projectId ?? ''}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
